import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import SkyLight from "react-skylight";
import moment from "moment";
import "./product.css";
import axios from "../../../config/axios";
import {
  InputGroup,
  Input,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Tooltip,
} from "reactstrap";
import {
  addFilter,
  deleteProduct,
  getProducts,
  getSubscription,
  updateProduct,
} from "../../../redux/reducers/seller";
import "react-toastify/dist/ReactToastify.css";
import "./../product.css";
import { ToastContainer, toast } from "react-toastify";
import { nextPagesItems } from "../../../helpers/custom";
import AddEditModal from "../../Events/AddEditModal";

const divStyle = { marginLeft: "60%" };
const myBigGreenDialog = { width: "35%", minHeight: "12%" };

const ProductList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const deleteProductModal = useRef(null);
  const eventProductModal = useRef(null);
  const approveProductModal = useRef(null);
  const {
    user: { userType },
    userLanguage,
    token: authToken,
  } = useSelector((state) => state.auth);
  const { translationState } = useSelector((state) => state.user);
  const { products, count, filters, loading, singleSubscription } = useSelector(
    (state) => state.seller
  );

  const [selectedId, setSelectedId] = useState(0);
  const [itemsPerPageOptions, setItemsPerPageOptions] = useState([
    5, 10, 50, 100,
  ]);
  const [actionType, setActionType] = useState("edit");
  const [productObj, setProductObj] = useState({
    id: "",
    name: "",
    description: "",
    startDate: moment().format("YYYY-MM-DDTHH:mm"),
    eventCategory: "event",
    regularPrice: 1,
    images: [],
    dynamicPrice: { currentPrice: 1 },
  });

  const [tooltipOpen, setTooltipOpen] = useState({
    view: {},
    edit: {},
    delete: {},
    meta: {},
  });
  const [metaConnected, setMetaConnected] = useState(false);
  const [selectedMetaProductId, setSelectedMetaProductId] = useState("");

  const toggle = (type, id) => {
    setTooltipOpen((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [id]: !prevState[type][id],
      },
    }));
  };

  const productTranslation =
    translationState?.[0]?.translations?.product?.[userLanguage];
  const reportingTranslation =
    translationState?.[0]?.translations?.reporting?.[userLanguage];
  const otherOrderTranslation =
    translationState?.[0]?.translations?.otherOrder?.[userLanguage];
  const metaTranslations = {
    connected: {
      en: "Meta account connected",
      fr: "Compte Meta connecte",
      es: "Cuenta de Meta conectada",
      zh: "Meta账号已连接",
      pt: "Conta Meta conectada",
      ar: "تم ربط حساب ميتا",
    },
    connectFailed: {
      en: "Meta connect failed. Please try again.",
      fr: "La connexion Meta a echoue. Veuillez reessayer.",
      es: "La conexion con Meta fallo. Intentalo de nuevo.",
      zh: "Meta连接失败。请重试。",
      pt: "Falha na conexao com a Meta. Tente novamente.",
      ar: "فشل الاتصال بميتا. يرجى المحاولة مرة أخرى.",
    },
    noAdAccount: {
      en: "No Meta ad account found. Create one in Meta Business Manager.",
      fr: "Aucun compte publicitaire Meta trouve. Creez-en un dans Meta Business Manager.",
      es: "No se encontro una cuenta publicitaria de Meta. Crea una en Meta Business Manager.",
      zh: "未找到Meta广告账户。请在Meta商务管理平台创建一个。",
      pt: "Nenhuma conta de anuncios Meta encontrada. Crie uma no Meta Business Manager.",
      ar: "لم يتم العثور على حساب إعلانات ميتا. أنشئ واحدًا في مدير أعمال ميتا.",
    },
    configMissing: {
      en: "Meta integration is not configured. Contact support.",
      fr: "L'integration Meta n'est pas configuree. Contactez le support.",
      es: "La integracion de Meta no esta configurada. Contacta al soporte.",
      zh: "Meta集成尚未配置。请联系支持团队。",
      pt: "A integracao da Meta nao esta configurada. Contate o suporte.",
      ar: "تكامل ميتا غير مهيأ. تواصل مع الدعم.",
    },
    pleaseLogin: {
      en: "Please log in",
      fr: "Veuillez vous connecter",
      es: "Por favor inicia sesion",
      zh: "请先登录",
      pt: "Por favor, faca login",
      ar: "يرجى تسجيل الدخول",
    },
    couldNotStartConnect: {
      en: "Could not start Meta connect",
      fr: "Impossible de demarrer la connexion Meta",
      es: "No se pudo iniciar la conexion con Meta",
      zh: "无法开始Meta连接",
      pt: "Nao foi possivel iniciar a conexao com a Meta",
      ar: "تعذر بدء الاتصال بميتا",
    },
    connectFailedGeneric: {
      en: "Connect Meta account failed",
      fr: "Echec de connexion au compte Meta",
      es: "Fallo al conectar la cuenta de Meta",
      zh: "连接Meta账户失败",
      pt: "Falha ao conectar a conta Meta",
      ar: "فشل ربط حساب ميتا",
    },
    paidRequired: {
      en: "Only paid YINN membership holders can advertise on Meta.",
      fr: "Seuls les membres YINN payants peuvent faire de la publicite sur Meta.",
      es: "Solo los miembros pagos de YINN pueden anunciarse en Meta.",
      zh: "只有付费YINN会员可以在Meta上投放广告。",
      pt: "Somente membros pagos da YINN podem anunciar na Meta.",
      ar: "فقط أعضاء YINN المدفوعون يمكنهم الإعلان على ميتا.",
    },
    connectModalTitle: {
      en: "Connect Meta (Facebook) account",
      fr: "Connecter le compte Meta (Facebook)",
      es: "Conectar cuenta de Meta (Facebook)",
      zh: "连接Meta（Facebook）账户",
      pt: "Conectar conta Meta (Facebook)",
      ar: "ربط حساب ميتا (فيسبوك)",
    },
    connectModalDesc: {
      en: "To advertise your products on Meta, connect your Meta account. You will be asked to log in with Facebook and then choose which ad account to connect.",
      fr: "Pour promouvoir vos produits sur Meta, connectez votre compte Meta. Vous devrez vous connecter avec Facebook puis choisir le compte publicitaire a connecter.",
      es: "Para anunciar tus productos en Meta, conecta tu cuenta de Meta. Se te pedira iniciar sesion con Facebook y luego elegir que cuenta publicitaria conectar.",
      zh: "要在Meta上推广您的产品，请连接您的Meta账户。系统会要求您使用Facebook登录，然后选择要连接的广告账户。",
      pt: "Para anunciar seus produtos na Meta, conecte sua conta Meta. Voce sera solicitado a fazer login com o Facebook e depois escolher qual conta de anuncios conectar.",
      ar: "للإعلان عن منتجاتك على ميتا، قم بربط حساب ميتا الخاص بك. سيُطلب منك تسجيل الدخول عبر فيسبوك ثم اختيار حساب الإعلانات الذي تريد ربطه.",
    },
    redirecting: {
      en: "Redirecting...",
      fr: "Redirection...",
      es: "Redirigiendo...",
      zh: "正在跳转...",
      pt: "Redirecionando...",
      ar: "جارٍ إعادة التوجيه...",
    },
    connectButton: {
      en: "Connect Meta account",
      fr: "Connecter le compte Meta",
      es: "Conectar cuenta de Meta",
      zh: "连接Meta账户",
      pt: "Conectar conta Meta",
      ar: "ربط حساب ميتا",
    },
    cancel: {
      en: "Cancel",
      fr: "Annuler",
      es: "Cancelar",
      zh: "取消",
      pt: "Cancelar",
      ar: "إلغاء",
    },
    advertise: {
      en: "Advertise on Meta",
      fr: "Faire de la publicite sur Meta",
      es: "Anunciar en Meta",
      zh: "在Meta上投放广告",
      pt: "Anunciar na Meta",
      ar: "الإعلان على ميتا",
    },
    paidRequiredShort: {
      en: "Paid YINN membership required",
      fr: "Abonnement YINN payant requis",
      es: "Se requiere membresia YINN de pago",
      zh: "需要付费YINN会员",
      pt: "Associacao YINN paga obrigatoria",
      ar: "يلزم اشتراك YINN مدفوع",
    },
    activeRequired: {
      en: "You can advertise on Meta only after an admin sets this product to Active.",
      fr: "Vous ne pouvez annoncer sur Meta qu'apres qu'un administrateur ait mis le produit sur Actif.",
      es: "Solo puedes anunciar en Meta cuando un administrador deje el producto en Activo.",
      zh: "仅当管理员将商品设为“上架/激活”后，您才可在 Meta 投放广告。",
      pt: "So e possivel anunciar no Meta depois que um admin definir o produto como Ativo.",
      ar: "يمكنك الإعلان على ميتا فقط بعد أن يضع المشرف المنتج حالة «نشط».",
    },
    activeRequiredShort: {
      en: "Product must be Active (admin approved)",
      fr: "Le produit doit etre Actif (approuve par l'admin)",
      es: "El producto debe estar Activo (aprobado por admin)",
      zh: "商品须为已激活（管理员已通过）",
      pt: "O produto deve estar Ativo (aprovado pelo admin)",
      ar: "يجب أن يكون المنتج «نشطًا» (بعد موافقة المشرف)",
    },
    attributeOrders: {
      en: "Attribute Orders",
      fr: "Commandes d'attribution",
      es: "Ordenes de atribucion",
      zh: "属性订单",
      pt: "Pedidos de atribuicao",
      ar: "طلبات الإسناد",
    },
    ads: {
      en: "Ads",
      fr: "Publicites",
      es: "Anuncios",
      zh: "广告",
      pt: "Anuncios",
      ar: "إعلانات",
    },
  };
  const { value: pageNo } = filters.find((item) => item.field === "pageNo");
  const { value: perPage } = filters.find((item) => item.field === "perPage");
  const [selectedPerPage, setSelectedPerPage] = useState(perPage);
  const membershipType = String(singleSubscription?.membershipType || "").toLowerCase();
  const isPaidMembershipHolder =
    !!membershipType && membershipType !== "fremium" && membershipType !== "freemium";
  const isProductStatusActive = (status) =>
    String(status || "").trim().toLowerCase() === "active";

  useEffect(() => {
    dispatch(addFilter({ field: "digitalType", value: "" }));
    dispatch(addFilter({ field: "type", value: "physical" }));
    dispatch(addFilter({ field: "pageNo", value: 1 }));
    dispatch(addFilter({ field: "perPage", value: 5 }));
    setSelectedPerPage(5);
    dispatch(getProducts());
  }, []);

  useEffect(() => {
    if (userType !== "seller" || !authToken) return;
    axios
      .get("/ad-accounts", { headers: { Authorization: `Bearer ${authToken}` } })
      .then((res) => setMetaConnected((res.data.data || []).length > 0))
      .catch(() => setMetaConnected(false));
  }, [userType, authToken]);

  useEffect(() => {
    if (userType !== "seller" || !authToken) return;
    dispatch(getSubscription());
  }, [dispatch, userType, authToken]);

  useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    if (params.get("meta_connected") === "1") {
      setMetaConnected(true);
      toast.success(metaTranslations.connected[userLanguage] || metaTranslations.connected.en);
      const nextProductId = window.sessionStorage.getItem("meta_advertise_product_id");
      if (nextProductId) {
        window.sessionStorage.removeItem("meta_advertise_product_id");
        history.push(`/seller/social-advertisement/${nextProductId}`);
        return;
      }
    }
    const err = params.get("meta_connect_error");
    if (err === "1")
      toast.error(metaTranslations.connectFailed[userLanguage] || metaTranslations.connectFailed.en);
    if (err === "no_ad_account")
      toast.error(metaTranslations.noAdAccount[userLanguage] || metaTranslations.noAdAccount.en);
    if (err === "config")
      toast.error(metaTranslations.configMissing[userLanguage] || metaTranslations.configMissing.en);
  }, [location.search, history]);

  const connectMetaModal = useRef(null);
  const [metaConnectLoading, setMetaConnectLoading] = useState(false);

  const startMetaConnect = () => {
    if (!authToken) {
      toast.error(metaTranslations.pleaseLogin[userLanguage] || metaTranslations.pleaseLogin.en);
      return;
    }
    if (selectedMetaProductId) {
      window.sessionStorage.setItem("meta_advertise_product_id", selectedMetaProductId);
    }
    setMetaConnectLoading(true);
    axios
      .get("/auth/meta-ads/connect", { headers: { Authorization: `Bearer ${authToken}` } })
      .then((res) => {
        if (res.data && res.data.url) {
          window.location.href = res.data.url;
          return;
        }
        setMetaConnectLoading(false);
        toast.error(
          res.data?.message ||
            metaTranslations.couldNotStartConnect[userLanguage] ||
            metaTranslations.couldNotStartConnect.en
        );
      })
      .catch((err) => {
        setMetaConnectLoading(false);
        const msg =
          err.response?.data?.message ||
          err.message ||
          metaTranslations.connectFailedGeneric[userLanguage] ||
          metaTranslations.connectFailedGeneric.en;
        toast.error(msg);
      });
  };

  const handleMetaAdvertiseClick = (productId) => {
    if (userType !== "seller") return;
    if (!isPaidMembershipHolder) {
      toast.error(metaTranslations.paidRequired[userLanguage] || metaTranslations.paidRequired.en);
      return;
    }
    const row = (products || []).find((p) => String(p._id) === String(productId));
    if (row && !isProductStatusActive(row.status)) {
      toast.error(metaTranslations.activeRequired[userLanguage] || metaTranslations.activeRequired.en);
      return;
    }
    if (!authToken) {
      toast.error(metaTranslations.pleaseLogin[userLanguage] || metaTranslations.pleaseLogin.en);
      return;
    }
    setSelectedMetaProductId(productId);
    connectMetaModal.current && connectMetaModal.current.show();
  };

  const approveModal = (id) => {
    setSelectedId(id);
    approveProductModal.current.show();
  };
  const approveProduct = () => {
    const data = {
      id: selectedId,
      status: "Active",
    };
    dispatch(updateProduct(data)).then(() => {
      approveProductModal.current.hide();
      dispatch(getProducts());
    });
  };
  const rejectProduct = () => {
    const data = {
      id: selectedId,
      status: "Rejected",
    };
    dispatch(updateProduct(data)).then(() => {
      approveProductModal.current.hide();
      dispatch(getProducts());
    });
  };
  const deleteModal = (id) => {
    setSelectedId(id);
    deleteProductModal.current.show();
  };
  const deleteItem = () => {
    dispatch(deleteProduct(selectedId)).then(() => {
      deleteProductModal.current.hide();
      dispatch(getProducts());
    });
  };
  const searchElement = (evt) => {
    dispatch(
      addFilter({
        field: "pageNo",
        value: 1,
      })
    );
    dispatch(
      addFilter({
        field: "search",
        value: evt.target.value,
      })
    );
    dispatch(getProducts());
  };

  const nextCount = nextPagesItems(Math.abs(pageNo - 1), perPage, count);
  const clickableNext = nextCount > perPage;
  const paginate = (pageNo) => {
    if (pageNo > 0 && nextCount > 0) {
      dispatch(
        addFilter({
          field: "pageNo",
          value: pageNo,
        })
      );
      dispatch(
        addFilter({
          field: "perPage",
          value: perPage,
        })
      );
      dispatch(getProducts());
    }
  };
  const perPageHandler = (e, pageNo) => {
    setSelectedPerPage(Number(e.target.value));
    dispatch(
      addFilter({
        field: "pageNo",
        value: pageNo,
      })
    );
    dispatch(
      addFilter({
        field: "perPage",
        value: Number(e.target.value),
      })
    );
    dispatch(getProducts());
  };
  const showProduct = (id) => {
    const product = products.find((prod) => prod._id === id);
    if (product?.eventCategory === "event") {
      const startDate = product?.startDate;
      const formattedStartDate = moment(startDate).format("YYYY-MM-DDTHH:mm");
      setProductObj({
        ...productObj,
        ...product,
        id,
        startDate: formattedStartDate,
      });
      setActionType("view");
      eventProductModal.current.show();
    } else {
      if (userType === "admin") {
        history.push(`/admin/products/view/${id}`);
      } else {
        history.push(`/seller/products/viewproduct/${id}`);
      }
    }
  };
  const editProduct = (id) => {
    const product = products.find((prod) => prod._id === id);
    if (product.eventCategory === "event") {
      const startDate = product?.startDate;
      const formattedStartDate = moment(startDate).format("YYYY-MM-DDTHH:mm");
      setProductObj({
        ...productObj,
        ...product,
        id,
        startDate: formattedStartDate,
      });
      setActionType("edit");
      eventProductModal.current.show();
    } else {
      if (userType === "admin") {
        history.push(`/admin/products/edit/${id}`);
      } else {
        history.push(`/seller/products/editproduct/${id}`);
      }
    }
  };
  const handleOnSubmit = async (data) => {
    const {
      name,
      description,
      startDate,
      eventCategory,
      images,
      dynamicPrice,
    } = data;
    if (
      !name ||
      !description ||
      !startDate ||
      !eventCategory ||
      !images?.length ||
      !dynamicPrice.currentPrice
    ) {
      return toast.error("All fields are required");
    }
    if (actionType === "edit") {
      await dispatch(updateProduct(data));
    }
    eventProductModal.current.hide();
    setProductObj({
      ...data,
      id: "",
      name: "",
      description: "",
      startDate: moment().format("YYYY-MM-DDTHH:mm"),
      eventCategory: "event",
      regularPrice: 1,
      images: [],
      dynamicPrice: { currentPrice: 1 },
    });
    dispatch(getProducts());
  };

  return (
    <div className="animated fadeIn dialog-Overlay">
      <ToastContainer autoClose={20000} />
      <AddEditModal
        ref={eventProductModal}
        eventContent={productObj}
        type={actionType}
        onSubmit={handleOnSubmit}
      />
      <SkyLight
        dialogStyles={myBigGreenDialog}
        hideOnOverlayClicked
        ref={approveProductModal}
        title={
          <b
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "14px",
              margin: "8px",
            }}
          >
            Are you sure you want to Approve or Reject this Product?
          </b>
        }
      >
        <Row style={{ display: "flex", justifyContent: "center" }}>
          {products?.find((item) => selectedId === item._id)?.status !==
            "Active" && (
            <>
              <Button
                type="submit"
                onClick={approveProduct}
                size="md"
                color="warning"
              >
                Approve
              </Button>
              <Col xs="12" sm="1"></Col>
            </>
          )}
          {products?.find((item) => selectedId === item._id)?.status !==
            "Rejected" && (
            <Button
              type="submit"
              size="md"
              onClick={rejectProduct}
              color="danger"
            >
              Reject
            </Button>
          )}
        </Row>
      </SkyLight>
      <SkyLight
        dialogStyles={myBigGreenDialog}
        hideOnOverlayClicked
        ref={deleteProductModal}
        title={
          <b style={{ display: "flex", justifyContent: "center" }}>
            <h4>Are you sure you want to delete this Product?</h4>
          </b>
        }
      >
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Button type="submit" onClick={deleteItem} size="md" color="warning">
            Yes
          </Button>
          <Col xs="12" sm="1"></Col>
          <Button
            type="submit"
            size="md"
            onClick={() => deleteProductModal.current.hide()}
            color="danger"
          >
            No
          </Button>
        </Row>
      </SkyLight>
      <SkyLight
        dialogStyles={myBigGreenDialog}
        hideOnOverlayClicked
        ref={connectMetaModal}
        title={
          <b style={{ display: "flex", justifyContent: "center", fontSize: "14px" }}>
            {metaTranslations.connectModalTitle[userLanguage] || metaTranslations.connectModalTitle.en}
          </b>
        }
      >
        <p style={{ textAlign: "center", marginBottom: "16px" }}>
          {metaTranslations.connectModalDesc[userLanguage] || metaTranslations.connectModalDesc.en}
        </p>
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Button
            color="primary"
            onClick={startMetaConnect}
            disabled={metaConnectLoading}
          >
            {metaConnectLoading
              ? metaTranslations.redirecting[userLanguage] || metaTranslations.redirecting.en
              : metaTranslations.connectButton[userLanguage] || metaTranslations.connectButton.en}
          </Button>
          <Col xs="12" sm="1"></Col>
          <Button
            color="secondary"
            onClick={() => connectMetaModal.current && connectMetaModal.current.hide()}
            disabled={metaConnectLoading}
          >
            {metaTranslations.cancel[userLanguage] || metaTranslations.cancel.en}
          </Button>
        </Row>
      </SkyLight>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <div className=" d-flex justify-content-between align-items-center">
                <div>
                  <b style={{ fontSize: "14px" }}>
                    {productTranslation?.list
                      ? productTranslation?.list
                      : "Product List"}
                  </b>
                </div>
                <div className="d-flex align-items-center">
                  {userType === "seller" && !metaConnected && (
                    <Button
                      size="sm"
                      className="mr-2"
                      style={{ padding: "10px 5px" }}
                      color="info"
                      onClick={() => connectMetaModal.current && connectMetaModal.current.show()}
                    >
                      <b>{metaTranslations.connectButton[userLanguage] || metaTranslations.connectButton.en}</b>
                    </Button>
                  )}
                  {userType === "seller" && (
                    <Button
                      size="sm"
                      style={{ padding: "10px 5px" }}
                      color="warning"
                      onClick={() => history.push("/seller/products/add")}
                    >
                      <b>
                        {productTranslation?.addButton
                          ? productTranslation?.addButton
                          : "Add Product"}
                      </b>
                    </Button>
                  )}
                </div>
              </div>
            </CardHeader>
            <CardBody className="card-body">
              <Row>
                <Col xs="12" sm="4">
                  <InputGroup>
                    <Input
                      type="text"
                      id="input1-group2"
                      onChange={searchElement}
                      className="search-color"
                      name="input1-group2"
                      placeholder={
                        productTranslation?.search
                          ? productTranslation?.search
                          : "search ..."
                      }
                    />
                  </InputGroup>
                </Col>
              </Row>
              <br />
              <div className="tableFixHead">
                <Table hover bordered striped responsive size="sm">
                  <thead align="center" style={{ position: "sticky" }}>
                    <tr className="header-color">
                      <th>
                        {productTranslation?.name
                          ? productTranslation?.name
                          : "Name"}{" "}
                      </th>
                      <th>
                        {productTranslation?.brand
                          ? productTranslation?.brand
                          : "Brand"}
                      </th>
                      <th>
                        {productTranslation?.stockQuantity
                          ? productTranslation?.stockQuantity
                          : "Stock Quantity"}
                      </th>
                      <th>MRPS</th>
                      <th>
                        {productTranslation?.salePrice
                          ? productTranslation?.salePrice
                          : "Sale Price"}
                      </th>
                      <th>
                        {productTranslation?.shippingCharges
                          ? productTranslation?.shippingCharges
                          : "Shipping Charges"}
                      </th>
                      <th>
                        {productTranslation?.action
                          ? productTranslation?.action
                          : "Action"}{" "}
                      </th>
                      <th>
                        {productTranslation?.status
                          ? productTranslation?.status
                          : "Status"}
                      </th>
                      {userType === "seller" && (
                        <th>
                          <span className="d-none d-md-inline">
                            {metaTranslations.attributeOrders[userLanguage] ||
                              metaTranslations.attributeOrders.en}
                          </span>
                          <span className="d-md-none">
                            {metaTranslations.ads[userLanguage] || metaTranslations.ads.en}
                          </span>
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <th colSpan={userType === "seller" ? 9 : 8} className="py-5">
                          <div style={{ textAlign: "center" }}>
                            <i
                              className="fas fa-spinner fa-pulse fa-2x"
                              style={{ color: "green" }}
                            ></i>
                          </div>
                        </th>
                      </tr>
                    ) : products.length > 0 && !loading ? (
                      products.map((item, index) => {
                        const oldItem = item.translatedArray.find(
                          (item) => item.language === userLanguage
                        );
                        return (
                          <tr
                            hidden={item.product_type == "digital"}
                            key={index}
                          >
                            <td>{oldItem?.name ? oldItem?.name : item.name}</td>
                            <td>
                              {oldItem?.brand ? oldItem?.brand : item.brand}
                            </td>
                            <td align="center">
                              {item.eventCategory === "event"
                                ? "\u221E"
                                : item.stockQuantity}
                            </td>
                            <td align="center">$ {item.regularPrice}</td>
                            <td align="center">$ {item.salesPrice}</td>
                            <td align="center">$ {item.shippingCharges}</td>
                            <td align="center">
                              <i
                                className="fa fa-eye fa-lg mt-4"
                                id={`view-${item._id}`}
                                onClick={(e) => showProduct(item._id)}
                                style={{ cursor: "pointer" }}
                              ></i>
                              <Tooltip
                                placement="top"
                                isOpen={tooltipOpen.view[item._id]}
                                target={`view-${item._id}`}
                                toggle={() => toggle("view", item._id)}
                                className="custom-tooltip"
                              >
                                View Product
                              </Tooltip>

                              <i
                                className="fa fa-edit fa-lg mt-4"
                                id={`edit-${item._id}`}
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "8px",
                                  marginRight: "8px",
                                }}
                                onClick={(e) => editProduct(item._id, index)}
                              ></i>
                              <Tooltip
                                placement="top"
                                isOpen={tooltipOpen.edit[item._id]}
                                target={`edit-${item._id}`}
                                toggle={() => toggle("edit", item._id)}
                                className="custom-tooltip"
                              >
                                Edit Product
                              </Tooltip>

                              <i
                                className="fa fa-trash fa-lg mt-4"
                                id={`delete-${item._id}`}
                                onClick={(e) => deleteModal(item._id)}
                                style={{ cursor: "pointer" }}
                              ></i>
                              <Tooltip
                                placement="top"
                                isOpen={tooltipOpen.delete[item._id]}
                                target={`delete-${item._id}`}
                                toggle={() => toggle("delete", item._id)}
                                className="custom-tooltip"
                              >
                                Delete Product
                              </Tooltip>
                            </td>
                            {userType === "seller" && (
                              <td
                                align="center"
                                style={{
                                  color:
                                    item.status ===
                                    `${
                                      productTranslation?.rejected
                                        ? productTranslation?.rejected
                                        : "Rejected"
                                    }`
                                      ? "red"
                                      : item.status ===
                                        `${
                                          productTranslation?.active
                                            ? productTranslation?.active
                                            : "Actives"
                                        }`
                                      ? "green"
                                      : "",
                                }}
                              >
                                {item.status === "Pending"
                                  ? `${
                                      otherOrderTranslation?.pending
                                        ? otherOrderTranslation?.pending
                                        : "Pending"
                                    }`
                                  : item.status === "Active"
                                  ? `${
                                      productTranslation?.active
                                        ? productTranslation?.active
                                        : "Active"
                                    }`
                                  : `${
                                      productTranslation?.rejected
                                        ? productTranslation?.rejected
                                        : "Rejected"
                                    }`}
                              </td>
                            )}
                            {userType === "admin" && (
                              <td align="center">
                                <Button
                                  onClick={() => {
                                    approveModal(item._id);
                                  }}
                                  style={{
                                    backgroundColor:
                                      item.status ===
                                      `${
                                        productTranslation?.pending
                                          ? productTranslation?.pending
                                          : "Pending"
                                      }`
                                        ? "#FFCC00"
                                        : item.status ===
                                          `${
                                            productTranslation?.active
                                              ? productTranslation?.active
                                              : "Active"
                                          }`
                                        ? "green"
                                        : "red",
                                    color: "white",
                                  }}
                                >
                                  {item.status ===
                                  `${
                                    productTranslation?.pending
                                      ? productTranslation?.pending
                                      : "Pending"
                                  }`
                                    ? item.status
                                    : item.status ===
                                      `${
                                        productTranslation?.active
                                          ? productTranslation?.active
                                          : "Active"
                                      }`
                                    ? `${
                                        productTranslation?.approved
                                          ? productTranslation?.approved
                                          : "Approved"
                                      }`
                                    : item.status}
                                </Button>
                              </td>
                            )}
                            {userType === "seller" && (
                              <td align="center" className="align-middle">
                                {(() => {
                                  const canMeta =
                                    isPaidMembershipHolder && isProductStatusActive(item.status);
                                  const metaTitle = !isPaidMembershipHolder
                                    ? metaTranslations.paidRequiredShort[userLanguage] ||
                                      metaTranslations.paidRequiredShort.en
                                    : !isProductStatusActive(item.status)
                                    ? metaTranslations.activeRequiredShort[userLanguage] ||
                                      metaTranslations.activeRequiredShort.en
                                    : metaTranslations.advertise[userLanguage] || metaTranslations.advertise.en;
                                  const metaTooltipLong = !isPaidMembershipHolder
                                    ? metaTranslations.paidRequired[userLanguage] || metaTranslations.paidRequired.en
                                    : !isProductStatusActive(item.status)
                                    ? metaTranslations.activeRequired[userLanguage] ||
                                      metaTranslations.activeRequired.en
                                    : metaTranslations.advertise[userLanguage] || metaTranslations.advertise.en;
                                  return (
                                    <>
                                      <span
                                        id={`meta-${item._id}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => handleMetaAdvertiseClick(item._id)}
                                        onKeyDown={(e) =>
                                          e.key === "Enter" && handleMetaAdvertiseClick(item._id)
                                        }
                                        style={{
                                          cursor: canMeta ? "pointer" : "not-allowed",
                                          fontSize: "1.2rem",
                                          opacity: canMeta ? 1 : 0.5,
                                        }}
                                        title={metaTitle}
                                      >
                                        <i
                                          className="fab fa-facebook"
                                          style={{ color: "#1877f2" }}
                                          aria-hidden
                                        />
                                      </span>
                                      <Tooltip
                                        placement="top"
                                        isOpen={tooltipOpen.meta[item._id]}
                                        target={`meta-${item._id}`}
                                        toggle={() => toggle("meta", item._id)}
                                        className="custom-tooltip"
                                      >
                                        {metaTooltipLong}
                                      </Tooltip>
                                    </>
                                  );
                                })()}
                              </td>
                            )}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={userType === "seller" ? 9 : 8} className="py-5">
                          <div style={{ textAlign: "center" }}>
                            <p style={{ color: "red" }}>
                              {productTranslation?.notAvailable
                                ? productTranslation?.notAvailable
                                : "Products not Available"}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
              <nav className="mt-3">
                <Pagination>
                  <PaginationItem>
                    <PaginationLink
                      onClick={(e) => paginate(pageNo - 1)}
                      disabled={pageNo === 1 ? true : false}
                      style={{
                        backgroundColor:
                          (pageNo === 1 ? true : false) && "#e4e7ea",
                      }}
                    >
                      {reportingTranslation?.previousButton
                        ? reportingTranslation?.previousButton
                        : "Prev"}
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink
                      onClick={() => paginate(pageNo + 1)}
                      disabled={!clickableNext}
                      style={{
                        backgroundColor: !clickableNext ? "#e4e7ea" : null,
                      }}
                      className="ml-2 mr-2"
                    >
                      {reportingTranslation?.nextButton
                        ? reportingTranslation?.nextButton
                        : "Next"}
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem className={"ml-auto"}>
                    <PaginationLink
                      className="rounded"
                      style={{
                        color: "black",
                        hover: false,
                        backgroundColor: "white",
                      }}
                    >
                      <div>
                        {productTranslation?.itemPerPage
                          ? productTranslation?.itemPerPage
                          : "Items per Page"}
                        <select
                          className="ml-2"
                          value={selectedPerPage}
                          onChange={(e) => perPageHandler(e, pageNo)}
                        >
                          {itemsPerPageOptions.map((option, i) => (
                            <option key={i} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </nav>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ProductList;
